import { ERROR, LOADING, SUCCESS } from './ExportingActions';

const INITIAL_STATE = {
  isLoading: false,
  success: false,
};

const ExportingReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOADING: {
      return { ...state, isLoading: action.isLoading };
    }
    case SUCCESS: {
      return { ...state, isLoading: false, success: true };
    }
    default:
      return state;
  }
};

export default ExportingReducer;
